import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { adminInquirySendResponse } from '@api/adminInquiries';

export const handleAdminSupplementSendInquiry = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('adminSupplementSendInquiry', adminInquirySendResponse);
